import React from "react";
import useLinks from "@hooks/useLinks";
import useWindow from "@hooks/useWindow";
import useWindowDimensions from "@hooks/useWindowDimensions";
import { LINKS } from "@constants";
import { StyledSectionTitle, StyledThirdLinksSection } from "../../components/Header/components/LinksContainer/styled";

const useLinksContainerConfiguration = (path, setShowLinks) => {
    const generateLinks = useLinks();
    const isWindowDefined = useWindow();
    const { isDesktop } = useWindowDimensions();

    const thirdLinksContainerMarkup = (
        <StyledThirdLinksSection>
            <StyledSectionTitle>Company</StyledSectionTitle>
            {generateLinks(LINKS.company, false, path, setShowLinks)}
        </StyledThirdLinksSection>
    );

    return {
        isWindowDefined,
        isDesktop,
        thirdLinksContainerMarkup,
        generateLinks
    };
};

export default useLinksContainerConfiguration;